import { array, string, struct } from 'io-ts/Decoder';

import { WholeHouseId as WholeHouseAncillaryItemId } from '../../../../job/ancillary-item';
import { Type as Ingredient } from '../../../../whole-house/recipe/ingredient/Type';
import { Id as MeasurementType } from '../../../../whole-house/recipe/measurement';

export const Request = struct({
	name: string,
	takeoffType: WholeHouseAncillaryItemId,
	measurementType: MeasurementType,
	ingredients: array(Ingredient),
});
